<template>
  <div>
    Procedimientos ->
  </div>
</template>

<script>
import { PROCEDURE_FRONT } from '@/procedures/requests.js';
export default {
  created () {
    // "contractor_coordinator"
    // coordinator
    const token = localStorage.getItem('token')
    const userId = this.$store.getters.user._id;
    const faenaId = this.$store.getters.role.faena_id
    const role = this.$store.getters.role.role
    const admin = this.$store.getters.role.admin

    const urlLogin = `${PROCEDURE_FRONT}/loginFromInventory?token=${token}&userId=${userId}&faenaId=${faenaId}&role=${role}&admin=${admin}`;
    window.location.replace(urlLogin);
  }
}
</script>
